/*!
 * Location on maps component v0.0.1
 * Simple location on maps created in pure Javascript.
 *
 */

document.addEventListener("DOMContentLoaded", () => {
  waitForGoogleMaps(initLocationsOnMap);
});



function initLocationsOnMap() {
  // compoent parent selector to prevent conflicts of multiple components
  let parentSelectorForComponent = document.querySelectorAll(
    ".ps_s_locationonmaps_component_container"
  );
  if (!parentSelectorForComponent) {
    return false;
  }
  for (let i = 0; i < parentSelectorForComponent.length; i++) {
    let currentParentComponent = parentSelectorForComponent[i];

    // initialize a class, closure or prototype here
    let perPage = 10;
    if(window.innerWidth< 960){
      perPage = 3; 
    }
    let mapCreated = new PsSLocationOnMaps(
      currentParentComponent,
      siteUrl,
      templateDirectoryUri,
      perPage
    );
  }
}
function waitForGoogleMaps(callback) {
  const checkGoogle = setInterval(() => {
    if (typeof google !== "undefined" && google.maps) {
      clearInterval(checkGoogle);
      callback();
    }
  }, 100);
}


// creating a new class to handle maps

class PsSLocationOnMaps {
  constructor(currentParentComponent, siteUrl, templateDirectoryUri, psPerPage = 10) {
    this.currentParentComponent = currentParentComponent;
    this.siteUrl = siteUrl;
    this.templateDirectoryUri = templateDirectoryUri;
    this.map = null;
    this.markers = [];
    this.infoWindow = null;
    this.psCurrentPage = 1;
    this.currentSearchTerm = '';
    this.psPerPage = psPerPage;
    this.mobilePerPage = 1;
    this.psTotalPages = 1;
    this.totalCount = 0;
    this.psDebounceTimeout = null;
    this.allLocations = [];
    this.categoryIcons = {
      Technology: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
      Healthcare: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
      Marketing: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
      selected: `${this.templateDirectoryUri}/dist/images/location/pinselected.svg`,
      default: `${this.templateDirectoryUri}/dist/images/location/pin.svg`,
    };
    this.initMap();
    this.addEventListeners();
    this.loadFromUrlParams();
    this.addPaginationListeners();

  }

  initMap() {
    const mapElement = this.currentParentComponent.querySelector(
      ".ps-s-locationonmaps-map"
    );
    if (!mapElement) return;

    this.map = new google.maps.Map(mapElement, {
      // center: { lat: 40.748817, lng: -73.985428 },
      zoom: 5,
      styles: [
        { elementType: "geometry", stylers: [{ color: "#eeefe9" }] },
        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#c7c4c7" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [{ color: "#cbe2a7" }],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#b59ac9" }],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9e9e9e" }],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#c8b5d3" }],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{ color: "#6e6e6e" }],
        },
        {
          featureType: "road",
          elementType: "labels.text.stroke",
          stylers: [{ color: "#f5f5f5" }],
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#cee5f2" }],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9e9e9e" }],
        },
      ],
      disableDefaultUI: true, // Disables all default UI controls
      zoomControl: true, // Enables zoom control
      zoomControlOptions: {
        position: google.maps.ControlPosition.TOP_LEFT // Positioning the zoom control at the top left
      },
        gestureHandling: "greedy",
        draggable: true, // Force map to stay draggable
    });
    this.infoWindow = new google.maps.InfoWindow();
    // Fix: Ensure map remains interactive after dragging
    google.maps.event.addListener(this.map, "dragstart", () => {
      document.body.style.cursor = "grabbing"; // Show grabbing cursor
    });

    google.maps.event.addListener(this.map, "dragend", () => {
      document.body.style.cursor = "default"; // Reset cursor
      setTimeout(() => {
        google.maps.event.trigger(this.map, "resize");
      }, 100);
    });

    google.maps.event.addListener(this.map, "click", () => {
      this.infoWindow.close(); // Close info window on outside clicks
    });
  }
  updateLocationList(data) {
    const listWrapper =
      this.currentParentComponent.querySelector(".search-list");
    if (!listWrapper) {
      // console.error("Error: Element with class 'search-list' not found!");
      return;
    }

    listWrapper.innerHTML = ""; // Clear the list before updating

    // Check if there are locations to display
    if (!Array.isArray(data) || data.length === 0) {
      listWrapper.innerHTML = '<p class="no-results">No locations found.</p>';
      return;
    }

    // Render each location
    data.forEach((location) => {
      const li = document.createElement("li");
      li.classList.add("location-item");
      //const listItem = document.createElement('li');
      //listItem.textContent = location.title;
      li.onclick = () => this.zoomToLocation(location);
      const locationContent = `
            <div class="list-content-wrapper">
                <div>
                    <img src="${this.templateDirectoryUri}/dist/images/location/${location.icon}" alt="${location.title}" class="location_icon" />
                </div>
                <div>
                    <div class="location-title"><h2>${location.title}</h2></div>
                    <div class="location-address"><p>${location.address}, ${location.geo_location.city}</p></div>
                    <div class="location-jobs">
                        <a href="${this.siteUrl}/search-jobs?locations=${encodeURIComponent(location.geo_location.address)}" target="_blank" class="jobs-link">${location.jobs_message}</a>
                    </div>
                </div>
            </div>`;

      li.innerHTML = locationContent;
      listWrapper.appendChild(li);
    });
  }

  updateMapMarkers(filteredLocations) {
    //  console.log("Updating markers...", filteredLocations); // ✅ Debugging Log
    const bounds = new google.maps.LatLngBounds();
    this.markers.forEach((marker) => marker.setMap(null));
    this.markers = [];

    // Define default and selected icons
    const defaultIcon = this.categoryIcons["default"];
    const selectedIcon = this.categoryIcons["selected"];
    // Variable to track the currently selected marker
    let selectedMarker = null;
    filteredLocations.forEach((location) => {
      if (
        !location.geo_location ||
        typeof location.geo_location.lat !== "number" ||
        typeof location.geo_location.lng !== "number"
      ) {
        // console.error("Invalid location data:", location);
        return;
      }

      // console.log( `Adding marker for: ${location.title} at (${location.geo_location.lat}, ${location.geo_location.lng})`); // ✅ Debugging Log

      const marker = new google.maps.Marker({
        position: {
          lat: location.geo_location.lat,
          lng: location.geo_location.lng,
        },
        map: this.map,
        title: location.title,
        icon: defaultIcon,
      });

      marker.addListener("click", () => {
        // Reset the previously selected marker's icon to default
        if (selectedMarker && selectedMarker !== marker) {
          selectedMarker.setIcon(defaultIcon);
        }

        // Set the clicked marker as the selected marker and change its icon
        selectedMarker = marker;
        marker.setIcon(selectedIcon);
        const contentString = `
              <div class="custom-popup">
                  <div class="location-title">${location.title}</div>
                  <div class="location-address">${location.address}, ${location.geo_location.city}</div>
                  <a href="${this.siteUrl}/search-jobs?locations=${encodeURIComponent(location.geo_location.city)}" target="_blank" class="jobs-link">${location.jobs_message}</a>
              </div>
          `;
        this.infoWindow.setContent(contentString);
        this.infoWindow.open(this.map, marker);
      });

      this.markers.push(marker);
    });
    //console.log("Map Object:", this.map);
    // Adjust Zoom & Center to Fit Markers
    if (filteredLocations.length > 1) {
      // Fit bounds for multiple markers
      filteredLocations.forEach(location => bounds.extend(new google.maps.LatLng(location.geo_location.lat, location.geo_location.lng)));
      this.map.fitBounds(bounds); // Fit all markers into view
    } else if (filteredLocations.length === 1) {
      // For a single marker
      const location = filteredLocations[0];
      const latLng = new google.maps.LatLng(location.geo_location.lat, location.geo_location.lng);

      // Extend bounds to include this single location
      bounds.extend(latLng);
      this.map.fitBounds(bounds); // Fit the single marker into view

      // Set an appropriate zoom level to ensure the map is visible
      const zoomLevel = 14;  // Adjust as needed (for example, 10 to 14 is a good range)
      this.map.setZoom(zoomLevel);

      // Optionally, center the map directly on the single marker
      this.map.setCenter(latLng);
    }


    // Ensure the map updates correctly
    // setTimeout(() => {
    //   google.maps.event.trigger(this.map, "resize");
    //   this.map.fitBounds(bounds);
    // }, 300);
  }

  fetchPaginatedLocations(page = 1, searchTerm = "") {
    const apiUrl = `${this.siteUrl}/wp-json/ps-s/v1/locations?per_page=${this.psPerPage}&page=${page}&location_title=${searchTerm}`;
    fetch(apiUrl)
      .then((response) => {
        this.totalCount = response.headers.get("X-WP-Total");
        this.psTotalPages = Math.ceil(this.totalCount / this.psPerPage);
        return response.json();
      })
      .then((data) => {
        this.allLocations = data;
        if (page === 1) {
          this.fetchAllLocations(searchTerm);
        }
        this.updateLocationList(data);
        this.updatePagination();
        this.updateUrlWithParams(); // Update the URL whenever pagination or search changes
        // Update job counter
        const jobCounterDiv = document.querySelector('.job_counter p');
        jobCounterDiv.textContent = `${this.totalCount} results found`;  // Use total count from header
      })
      .catch((error) => console.error(""));
  }

  fetchAllLocations(searchTerm = "") {
    const apiUrl = `${this.siteUrl}/wp-json/ps-s/v1/locations?per_page=-1&location_title=${searchTerm}`;
    fetch(apiUrl)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.updateMapMarkers(data);
      })
      .catch((error) => console.error(""));
  }

  loadFromUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const query = params.get("query") || "";
    const page = parseInt(params.get("page")) || 1;
    const searchInput =
      this.currentParentComponent.querySelector(".search-input");
    if (searchInput) {
      searchInput.value = query;
    }
    this.psCurrentPage = page; // Set the current page from the URL
    this.fetchPaginatedLocations(this.psCurrentPage, query); // Fetch paginated data for the current page
  }

  addEventListeners() {
    const searchInput = this.currentParentComponent.querySelector(".search-input");
    const clearIcon = this.currentParentComponent.querySelector(".clear-icon");
    const map_icon = this.currentParentComponent.querySelector(".map_icon");

    // Ensure both elements exist
    if (!searchInput || !clearIcon) {
        console.warn('Search input or clear icon not found!');
        return;
    }

    // Function to toggle the visibility of the clear icon
    function toggleClearIcon() {
        if (searchInput.value.trim()) { // Check if there's any text in the input
            clearIcon.style.display = 'block'; // Show the clear icon
            map_icon.style.display = 'none'; // Hide the clear icon
        } else {
            clearIcon.style.display = 'none'; // Hide the clear icon
            map_icon.style.display = 'block'; // Show the clear icon
        }
    }

    // Event listener for input changes (debounced)
    searchInput.addEventListener("input", () => {
        clearTimeout(this.psDebounceTimeout);
        this.psDebounceTimeout = setTimeout(() => {
            this.psCurrentPage = 1; // Reset to page 1 when typing
            this.currentSearchTerm = searchInput.value.trim(); // Get trimmed search term

            // Fetch paginated locations based on the search term
            this.fetchPaginatedLocations(this.psCurrentPage, this.currentSearchTerm);
        }, 300); // Debounce time of 300ms
        toggleClearIcon(); // Call toggle function to update the clear icon visibility
    });

    // Event listener for the clear icon click to clear input field
    clearIcon.addEventListener('click', () => {
        searchInput.value = ''; // Clear the input field
        toggleClearIcon(); // Hide the clear icon after clearing the input
        searchInput.focus(); // Optionally refocus the input field
        this.psCurrentPage = 1; // Reset the page number
        this.fetchPaginatedLocations(this.psCurrentPage, ''); // Fetch with an empty search term
    });

    // Accessibility: Listen for keyboard events (Enter and Space) for .clear-icon
    clearIcon.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            // Trigger the click functionality when Enter or Space is pressed
            clearIcon.click();
        }
    });

    // Initialize clear icon visibility when the page loads
    toggleClearIcon();

    // Add event listener for the search button to trigger search manually
    const searchButton = this.currentParentComponent.querySelector(".ps_location_button");
    if (searchButton) {
        searchButton.addEventListener("click", () => {
            this.psCurrentPage = 1; // Reset to first page when button is clicked
            const searchTerm = searchInput.value.trim(); // Get the search term
            this.fetchPaginatedLocations(this.psCurrentPage, searchTerm); // Trigger search
        });
    }
}



  // updatePagination() {
  //   const paginationContainer = this.currentParentComponent.querySelector(".pagination-numbers");
  //   const prevButton = this.currentParentComponent.querySelector(".pagination-prev");
  //   const nextButton = this.currentParentComponent.querySelector(".pagination-next");
  //   const paginationcontrols = this.currentParentComponent.querySelector(".pagination-controls");

  //   if (!paginationContainer) return;
  //   paginationcontrols.style.visibility = "visible";
  //   paginationContainer.innerHTML = ""; // Clear existing pagination

  //   for (let i = 1; i <= this.psTotalPages; i++) {
  //     const pageButton = document.createElement("a");
  //     pageButton.classList.add("pagination-page");
  //     pageButton.textContent = i;
  //     pageButton.dataset.page = i;
  //     pageButton.href = "#"; // Add href so that it's focusable and accessible for keyboard navigation

  //     // Add aria-current to the active page
  //     if (i === this.psCurrentPage) {
  //       pageButton.classList.add("active");
  //       pageButton.setAttribute("aria-current", "page"); // Adds aria-current to indicate the current page
  //     }

  //     pageButton.addEventListener("click", (event) => {
  //       event.preventDefault(); // Prevent default action for the anchor tag
  //       this.psCurrentPage = i;
  //       this.updateUrlWithParams();
  //       this.fetchPaginatedLocations(i, this.currentSearchTerm);
  //     });

  //     paginationContainer.appendChild(pageButton);
  //   }

  //   // Enable/disable prev & next buttons and update aria-labels and aria-disabled attributes
  //   prevButton.classList.toggle("disabled", this.psCurrentPage === 1);
  //   nextButton.classList.toggle("disabled", this.psCurrentPage === this.psTotalPages);

  //   // Add aria-label and aria-disabled attributes
  //   prevButton.setAttribute("aria-label", "Previous page");
  //   prevButton.setAttribute("aria-disabled", this.psCurrentPage === 1 ? "true" : "false");

  //   nextButton.setAttribute("aria-label", "Next page");
  //   nextButton.setAttribute("aria-disabled", this.psCurrentPage === this.psTotalPages ? "true" : "false");
  // }
  updatePagination() {
    const paginationContainer = this.currentParentComponent.querySelector(".pagination-numbers");
    const prevButton = this.currentParentComponent.querySelector(".pagination-prev");
    const nextButton = this.currentParentComponent.querySelector(".pagination-next");
    const paginationcontrols = this.currentParentComponent.querySelector(".pagination-controls");

    if (!paginationContainer) return;
    paginationcontrols.style.visibility = "visible";
    paginationContainer.innerHTML = ""; // Clear existing pagination

    const totalPages = this.psTotalPages;
    const currentPage = this.psCurrentPage;

    function createPageButton(page) {
        const pageButton = document.createElement("a");
        pageButton.classList.add("pagination-page");
        pageButton.textContent = page;
        pageButton.dataset.page = page;
        pageButton.href = "#";

        if (page === currentPage) {
            pageButton.classList.add("active");
            pageButton.setAttribute("aria-current", "page");
        }

        pageButton.addEventListener("click", (event) => {
            event.preventDefault();
            this.psCurrentPage = page;
            this.updateUrlWithParams();
            this.fetchPaginatedLocations(page, this.currentSearchTerm);
        });

        return pageButton;
    }

    // Always show the first page
    paginationContainer.appendChild(createPageButton.call(this, 1));

    if (totalPages > 3) {
        // Show current page and neighbors if possible
        if (currentPage > 2) {
            paginationContainer.appendChild(createPageButton.call(this, currentPage - 1));
        }

        if (currentPage !== 1 && currentPage !== totalPages) {
            paginationContainer.appendChild(createPageButton.call(this, currentPage));
        }

        if (currentPage < totalPages - 1) {
            paginationContainer.appendChild(createPageButton.call(this, currentPage + 1));
        }

        // Show ellipsis if needed
        if (currentPage < totalPages - 2) {
            const ellipsis = document.createElement("span");
            ellipsis.textContent = "...";
            ellipsis.classList.add("pagination-ellipsis");
            paginationContainer.appendChild(ellipsis);
        }

        // Show last page
        paginationContainer.appendChild(createPageButton.call(this, totalPages));
    } else {
        // If 3 or fewer pages, just show all pages
        for (let i = 2; i <= totalPages; i++) {
            paginationContainer.appendChild(createPageButton.call(this, i));
        }
    }

    // Enable/disable prev & next buttons
    prevButton.classList.toggle("disabled", currentPage === 1);
    nextButton.classList.toggle("disabled", currentPage === totalPages);

    // Update aria attributes
    prevButton.setAttribute("aria-label", "Previous page");
    prevButton.setAttribute("aria-disabled", currentPage === 1 ? "true" : "false");

    nextButton.setAttribute("aria-label", "Next page");
    nextButton.setAttribute("aria-disabled", currentPage === totalPages ? "true" : "false");
}


  addPaginationListeners() {
    const prevButton =
      this.currentParentComponent.querySelector(".pagination-prev");
    const nextButton =
      this.currentParentComponent.querySelector(".pagination-next");

    if (prevButton) {
      prevButton.addEventListener("click", () => {
        if (this.psCurrentPage > 1) {
          this.psCurrentPage--;
          this.updateUrlWithParams();
          this.fetchPaginatedLocations(this.psCurrentPage, this.currentSearchTerm);
        }
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        if (this.psCurrentPage < this.psTotalPages) {
          this.psCurrentPage++;
          this.updateUrlWithParams();
          this.fetchPaginatedLocations(this.psCurrentPage, this.currentSearchTerm);
        }
      });
    }

  }

  updateUrlWithParams() {
    const searchInput =
      this.currentParentComponent.querySelector(".search-input");
    const searchTerm = searchInput ? searchInput.value.trim() : "";
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    params.set("query", searchTerm); // Update or add the search term
    params.set("page", this.psCurrentPage); // Update or add the current page number

    window.history.pushState({}, "", `${url.pathname}?${params.toString()}`);
  }

  // Zoom the map to a specific location
  zoomToLocation(location) {
    this.map.setCenter(new google.maps.LatLng(location.geo_location.lat, location.geo_location.lng));
    this.map.setZoom(14);

    // Trigger the marker click to show popup
    const marker = this.markers.find(marker => marker.getTitle() === location.title);

    if (marker) {
      google.maps.event.trigger(marker, 'click');
    }
  }





}


